export default __webpack_public_path__ + "static/media/telegram.8fd97eb7.svg";